import { type NodeViewProps } from '@tiptap/core'
import { NodeViewWrapper } from '@tiptap/react'
import _ from 'lodash'
import { Link2 } from 'lucide-react'
import { getCustomizerWidth } from '#app/components/tiptap/hooks/useCustomizer.js'
import { Input } from '#app/components/ui/input.js'
import {
	Tooltip,
	TooltipTrigger,
	TooltipProvider,
	TooltipContent,
} from '#app/components/ui/tooltip.js'
import { cn } from '#app/utils/misc.js'
import { handleInputName } from '../utils'

export const Component = (props: NodeViewProps) => {
	const editable = props.editor.isEditable
	const required = props.node.attrs.required
	const maxWidth = getCustomizerWidth(props)

	return (
		<NodeViewWrapper
			className="flex flex-col gap-2"
			style={{
				width: String(maxWidth) + 'px',
				maxWidth: '100%',
			}}
		>
			{editable ? (
				<div className="relative">
					<Input
						type="email"
						icon="AtSign"
						required={required}
						className="input-tt w-full appearance-none !pl-11"
						placeholder="Type something..."
						onChange={e => handleInputName(e.currentTarget.value, props)}
						value={props.node.attrs.placeholder}
					/>
					<div
						className={cn(
							'absolute',
							required
								? 'right-9 top-1/2 flex -translate-y-1/2 gap-2'
								: 'right-3 top-1/2 flex -translate-y-1/2 gap-2',
						)}
					>
						{props.node.attrs.to !== 'none' && (
							<>
								<TooltipProvider>
									<Tooltip>
										<TooltipTrigger>
											<Link2 width={16} />
										</TooltipTrigger>
										<TooltipContent>
											<p>
												This field is connected to the {props.node.attrs.to}{' '}
												field.
											</p>
										</TooltipContent>
									</Tooltip>
								</TooltipProvider>
							</>
						)}
					</div>
				</div>
			) : (
				<Input
					type="email"
					required={required}
					{...(!_.isEmpty(props.node.attrs.regex) && {
						pattern: props.node.attrs.regex,
					})}
					name={
						props.node.attrs.to !== 'none'
							? props.node.attrs.to
							: `data_${_.camelCase(props.node.attrs.name)}`
					}
					className="input-tt w-full appearance-none"
					placeholder={props.node.attrs.placeholder}
				/>
			)}
		</NodeViewWrapper>
	)
}

export default Component
